import React, { useEffect } from 'react';
import { Modal, Form, Col, Row, Input } from 'antd';

function CopyOrganizationModal(props: any) {
	const { visible, onClose, onSave, saving } = props;

	const [form] = Form.useForm();

	function saveForm(values: any) {
		onSave(values);
	}

	useEffect(() => {
		form.resetFields();
	}, [visible]);

	return (
		<Modal
			okText="Copy"
			cancelText="Cancel"
			title={'Copy data from another organization'}
			okButtonProps={{ loading: saving }}
			visible={visible}
			onOk={() => form.submit()}
			destroyOnClose={true}
			onCancel={onClose}
		>
			<Form form={form} id="userForm" onFinish={saveForm} layout="vertical">
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item label="Copy data from another organization">
							{`It will copy organization Aircrafts, Inventory, Contacts, Templates and Settings to selected organization. 
							It does not include activity and changelog`}
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item
							name="from_organization_id"
							label="Existing organization ID (Copy organization from live database)"
						>
							<Input placeholder="ID" />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
}

export default CopyOrganizationModal;
